// All service worker related events
export const SWEvents = {
  NEW_VERSION_AVAILABLE: "NEW_VERSION_AVAILABLE",
  CHECK_VERSION: "CHECK_VERSION",
};
